export const addCertificateAPI = {
  getExams: "host/content/exams/list",
};
